import { render, staticRenderFns } from "./GiftProducts.vue?vue&type=template&id=7831c64a&scoped=true&"
import script from "./GiftProducts.vue?vue&type=script&lang=js&"
export * from "./GiftProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7831c64a",
  null
  
)

export default component.exports